import { ActionTypes } from "../Constants/ActionTypes";

export const setIsMobileDevice = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.IS_MOBILE_DEVICE,
    payload: payload,
  });
};
export const setSchoolAdminProfileImage = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SCHOOL_ADMIN_PROFILE_IMAGE,
    payload: payload,
  });
};

export const resetSchoolAdminInformation = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RESET_SCHOOL_ADMIN_INFORMATION,
    payload: null,
  });
};

export const setDisableScreen = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_DISABLE_SCREEN,
    payload: payload,
  });
};

export const setDrawerOpen = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.TOGGLE_DRAWER,
    payload: payload,
  });
};
